import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

const BUTTONS = {
  CUSTOMER: {
    id: "customer",
    label: "Customer",
    shortcut: "F4",
    iconColor: "#2563eb",
    iconBg: "#dbeafe",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
        <circle cx="12" cy="7" r="4"></circle>
      </svg>
    ),
  },
  REPRINT: {
    id: "reprint",
    label: "Reprint Bill",
    iconColor: "#7c3aed",
    iconBg: "#ede9fe",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
        <path d="M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6"></path>
        <rect x="6" y="14" width="12" height="8" rx="1"></rect>
      </svg>
    ),
  },
  COMPLIMENTARY: {
    id: "complimentary",
    label: "Complimentary",
    iconColor: "#d97706",
    iconBg: "#fef3c7",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="3" y="8" width="18" height="4" rx="1"></rect>
        <path d="M12 8v13"></path>
        <path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"></path>
        <path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"></path>
      </svg>
    ),
  },
  CLEAR_CART: {
    id: "clearCart",
    label: "Clear Cart",
    iconColor: "#dc2626",
    iconBg: "#fee2e2",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M10 11v6"></path>
        <path d="M14 11v6"></path>
        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"></path>
        <path d="M3 6h18"></path>
        <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
      </svg>
    ),
  },
  RELEASE_TABLE: {
    id: "releaseTable",
    label: "Release Table",
    iconColor: "#0d9488",
    iconBg: "#ccfbf1",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 2v13"></path>
        <path d="m16 6-4-4-4 4"></path>
        <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path>
      </svg>
    ),
  },
  TRANSFER_TABLE: {
    id: "transferTable",
    label: "Transfer Table",
    iconColor: "#4f46e5",
    iconBg: "#e0e7ff",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="m16 3 4 4-4 4"></path>
        <path d="M20 7H4"></path>
        <path d="m8 21-4-4 4-4"></path>
        <path d="M4 17h16"></path>
      </svg>
    ),
  },
  HOLD_CART: {
    id: "holdCart",
    label: "Hold Cart",
    shortcut: "F6",
    iconColor: "#ea580c",
    iconBg: "#ffedd5",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="10"></circle>
        <path d="m15 9-6 6"></path>
        <path d="m9 9 6 6"></path>
      </svg>
    ),
  },
  DISCOUNT: {
    id: "discount",
    label: "Discounts",
    iconColor: "#16a34a",
    iconBg: "#dcfce7",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <line x1="19" x2="5" y1="5" y2="19"></line>
        <circle cx="6.5" cy="6.5" r="2.5"></circle>
        <circle cx="17.5" cy="17.5" r="2.5"></circle>
      </svg>
    ),
  },
  COUPON: {
    id: "coupon",
    label: "Coupons",
    shortcut: "F9",
    iconColor: "#a855f7",
    iconBg: "#faf5ff",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"></path>
        <path d="M13 5v2"></path>
        <path d="M13 17v2"></path>
        <path d="M13 11v2"></path>
      </svg>
    ),
  },
  OFFER: {
    id: "offer",
    label: "Offers",
    shortcut: "F10",
    iconColor: "#ca8a04",
    iconBg: "#fef9c3",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="3" y="8" width="18" height="4" rx="1"></rect>
        <path d="M12 8v13"></path>
        <path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"></path>
        <path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"></path>
      </svg>
    ),
  },
  LOYALTY: {
    id: "loyalty",
    label: "Loyalty",
    shortcut: "F8",
    iconColor: "#e11d48",
    iconBg: "#ffe4e6",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"></path>
      </svg>
    ),
  },
  PAYMENT_CONFIG: {
    id: "paymentConfig",
    label: "Payment Mode",
    iconColor: "#0284c7",
    iconBg: "#e0f2fe",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect width="20" height="14" x="2" y="5" rx="2"></rect>
        <line x1="2" x2="22" y1="10" y2="10"></line>
      </svg>
    ),
  },
  SEARCH_PRODUCTS: {
    id: "searchProducts",
    label: "Products",
    shortcut: "F3",
    iconColor: "#6d28d9",
    iconBg: "#ede9fe",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="11" cy="11" r="8"></circle>
        <path d="m21 21-4.3-4.3"></path>
      </svg>
    ),
  },
  NOTE: {
    id: "note",
    label: "Note",
    shortcut: "F11",
    iconColor: "#475569",
    iconBg: "#f1f5f9",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z"></path>
      </svg>
    ),
  },
  ADD_PRODUCT: {
    id: "addProduct",
    label: "Add Product",
    iconColor: "#2563eb",
    iconBg: "#dbeafe",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <line x1="12" y1="5" x2="12" y2="19"></line>
        <line x1="5" y1="12" x2="19" y2="12"></line>
      </svg>
    ),
  },
  PRICING_MODE: {
    id: "pricingMode",
    // Default (retail) appearance
    label: "Retail",
    iconColor: "#16a34a",
    iconBg: "#dcfce7",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2H2v10l9.29 9.29a1 1 0 0 0 1.41 0l6.59-6.59a1 1 0 0 0 0-1.41z"/>
        <circle cx="7" cy="7" r="2"/>
      </svg>
    ),
    // Activated (wholesale) appearance
    activatedLabel: "Wholesale",
    activatedIconColor: "#d97706",
    activatedIconBg: "#fef3c7",
    activatedIcon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9h18v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9Z"/>
        <path d="m3 9 2.45-4.9A2 2 0 0 1 7.24 3h9.52a2 2 0 0 1 1.8 1.1L21 9"/>
        <path d="M12 3v6"/>
      </svg>
    ),
  },
};

export const SIDEBAR_CONFIG = {
  RESTAURANT_CART_FINEDINE: [
    BUTTONS.CUSTOMER,
    BUTTONS.COMPLIMENTARY,
    BUTTONS.REPRINT,
    BUTTONS.CLEAR_CART,
    BUTTONS.RELEASE_TABLE,
    BUTTONS.TRANSFER_TABLE,
    BUTTONS.HOLD_CART,
    BUTTONS.ADD_PRODUCT,
    BUTTONS.DISCOUNT,
    BUTTONS.COUPON,
    BUTTONS.OFFER,
    BUTTONS.LOYALTY,
    BUTTONS.PAYMENT_CONFIG,
  ],

  RESTAURANT_CART_QSR: [
    BUTTONS.CUSTOMER,
    BUTTONS.COMPLIMENTARY,
    BUTTONS.REPRINT,
    BUTTONS.CLEAR_CART,
    BUTTONS.HOLD_CART,
    BUTTONS.ADD_PRODUCT,
    BUTTONS.DISCOUNT,
    BUTTONS.COUPON,
    BUTTONS.OFFER,
    BUTTONS.LOYALTY,
    BUTTONS.PAYMENT_CONFIG,
  ],

  GROCERY_CART: [
    BUTTONS.SEARCH_PRODUCTS,
    BUTTONS.CUSTOMER,
    BUTTONS.PRICING_MODE,
    BUTTONS.HOLD_CART,
    BUTTONS.LOYALTY,
    BUTTONS.COUPON,
    BUTTONS.OFFER,
    BUTTONS.CLEAR_CART,
    BUTTONS.PAYMENT_CONFIG,
  ],
};
